module.exports = __webpack_public_path__ + "img/mumbo-ac6eead1-6f2e-4b3b-4893-08d95b7e528f.png";